module.exports = __webpack_public_path__ + "static/media/8_potolok_10.63_0.f3ba3c22.png";